<template>
  <!-- Remove ripple because the glow gets cut off due to the closeness to the edge -->
  <VSwitch
    v-model="show"
    class="inline-switch v-input--reverse"
    :label="`Show ${label}`"
    :ripple="false"
  />
</template>

<script lang="ts">
import { defineComponent, ref, watch } from 'vue'

export default defineComponent({
  model: {
    event: 'toggle'
  },
  props: {
    value: {
      type: Boolean,
      required: true
    },
    // e.g. add-ons
    label: {
      type: String,
      required: true
    }
  },
  setup({ value }, { emit }) {
    const show = ref(value)
    watch(show, (shown) => {
      emit('toggle', shown)
    })
    return {
      show
    }
  }
})
</script>

<style scoped lang="scss">
// Tighten up vertical space around switch so it fits inline with text
.inline-switch {
  margin: 0;
  ::v-deep .v-messages {
    // Remove empty v-messages container after the switch to make it short
    display: none;
  }
}

// Reversed switch variant.
// The switch is often seen to the right of the switch.
// This also allows us to keep all controls aligned when the switch is right-aligned.
// https://codepen.io/alanaktion/pen/OJPQKdx
.v-input--reverse ::v-deep .v-input__slot {
  flex-direction: row-reverse;
  justify-content: flex-end;

  .v-application--is-ltr & {
    .v-input--selection-controls__input {
      margin-right: 0;
      margin-left: 8px;
    }
  }

  .v-application--is-rtl & {
    .v-input--selection-controls__input {
      margin-left: 0;
      margin-right: 8px;
    }
  }
}
</style>
